import { render, staticRenderFns } from "./QueryMore.vue?vue&type=template&id=20438016"
import script from "./QueryMore.vue?vue&type=script&lang=js"
export * from "./QueryMore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports